// extracted by mini-css-extract-plugin
export default {"attribute-list":"AttributeList_attribute-list__n6fof"};